export default __webpack_public_path__ + "static/media/txt_finish.dfc3ed24.png";